import React, { useRef, useState } from 'react';
import './SocialIcons.css';

export default function SocialIcons() {
    const gmailPlayer = useRef(null);
    const instagramPlayer = useRef(null);
    const facebookPlayer = useRef(null);
    const [copied, setCopied] = useState(false);

    const handleMouseEnter = (playerRef) => {
        playerRef.current.play();
    };

    const handleMouseLeave = (playerRef) => {
        playerRef.current.pause();
        playerRef.current.seek(0);
    };

    const handleGmailClick = (e) => {
        const isMobile = /Mobi|Android/i.test(navigator.userAgent);

        if (isMobile) {
            // 📱 Na telefonie – otwórz aplikację e-mail
            window.location.href = "mailto:meskilokal@gmail.com?subject=Rezerwacja%20w%20Męski%20Lokal";
        } else {
            // 💻 Na komputerze – skopiuj e-mail i pokaż popup
            e.preventDefault();
            navigator.clipboard.writeText("meskilokal@gmail.com");
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }
    };

    return (
        <>
            <div className="social-icons">
                <a
                    href="mailto:meskilokal@gmail.com"
                    target="_blank"
                    rel="noreferrer"
                    className="social-icon gmail"
                    onClick={handleGmailClick}
                    onMouseEnter={() => handleMouseEnter(gmailPlayer)}
                    onMouseLeave={() => handleMouseLeave(gmailPlayer)}
                >
                    <lottie-player
                        ref={gmailPlayer}
                        src="/images/gmail.json"
                        mode="normal"
                        background="transparent"
                        style={{ width: '100px', height: '100px' }}
                    />
                </a>

                <a
                    href="https://www.instagram.com/meski_lokal/"
                    target="_blank"
                    rel="noreferrer"
                    className="social-icon instagram"
                    onMouseEnter={() => handleMouseEnter(instagramPlayer)}
                    onMouseLeave={() => handleMouseLeave(instagramPlayer)}
                >
                    <lottie-player
                        ref={instagramPlayer}
                        src="/images/instagram.json"
                        mode="normal"
                        background="transparent"
                        style={{ width: '100px', height: '100px' }}
                    />
                </a>

                <a
                    href="https://www.facebook.com/profile.php?id=100063578858746"
                    target="_blank"
                    rel="noreferrer"
                    className="social-icon facebook"
                    onMouseEnter={() => handleMouseEnter(facebookPlayer)}
                    onMouseLeave={() => handleMouseLeave(facebookPlayer)}
                >
                    <lottie-player
                        ref={facebookPlayer}
                        src="/images/facebook.json"
                        mode="normal"
                        background="transparent"
                        style={{ width: '100px', height: '100px' }}
                    />
                </a>
            </div>

            {/* 💬 Popup "Skopiowano" tylko na desktopie */}
            {copied && (
                <div className="copied-popup">Skopiowano adres e-mail</div>
            )}
        </>
    );
}
